import {
  Box,
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
} from "@mui/material";
import React, { useState, useEffect } from "react";
import ButtonView from "../common/button/ButtonView";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import FormHelperText from "@mui/material/FormHelperText";
import moment from "moment";
import {
  DATE_FORMATE,
  DATE_REVISED_FILTER_BY_LABEL,
  DATE_CREATED_FILTER_BY_LABEL,
  HELPER_TEXT_STYLE,
  SELECT_SURVEY,
  SELECT_VEHICLE_TYPE,
} from "../../utils/GlobalConstants";
import DatePickerFilterBy from "../../components/common/datePicker/DatePickerFilterBy";
import "./styles/ImportForm.css";
import {
  fetchSurveyWithFilter,
  handleFetchAllSurveys,
  handleFetchVehicleType,
} from "../../services/ImportRequest";
import { useTranslation } from "react-i18next";

const ImportForm = ({
  handleFileUpload,
  handleFileInputClick,
  isFileUploadClick,
  uploadedFileName,
  handleHideShowTable,
  handleChangeFleetSurveyName,
  handleChangeVehicleType,
  fleetSurvetId,
  vehicleTypeId,
  isImportBtnCliked,
  disabled,
  fileExtension,
  handleClearFleetSurveyId,
}) => {
  const fileInput = React.useRef();
  const [show, setshow] = useState(false);
  const [allSurveyList, setAllSurveyList] = useState([]);
    const [allSurveyVehicleType, setAllSurveyVehicle] = useState([]);
  const [createdDate, setCreatedDate] = useState(null);
  const [revisedDate, setRevisedDate] = useState(null);
  const [isFilterWithDate, setIsFilterWithDate] = useState(false);
  const [isDateCreatedClicked, setIsDateCreatedClicked] = useState(false);
  const [isRevisedDateClicked, setIsRevisedDateClicked] = useState(false);
  const { t } = useTranslation();

  useEffect(() => {
    fetchSurvey();
    fetchVehicleTypes()
  }, []);

  const fetchSurvey = async () => {
    const response = await handleFetchAllSurveys();
    setAllSurveyList(response?.surveys);
  };
 const fetchVehicleTypes = async () => {
  try{
 
    const response = await handleFetchVehicleType();
    setAllSurveyVehicle(response?.vehicleTypes);
  
  }catch(e){
  setAllSurveyVehicle([]);
  
  }
    
  };

  const handleChangeDate = (val) => {
    setCreatedDate(moment(val.$d).format(DATE_FORMATE));
    setIsDateCreatedClicked(true);
    setIsRevisedDateClicked(false);
  };

  const handleChangeRevisedDate = (revised) => {
    setRevisedDate(moment(revised.$d).format(DATE_FORMATE));
    setIsRevisedDateClicked(true);
    setIsDateCreatedClicked(false);
  };

  const handleFetchSurveysWithFilter = async (name) => {
    if (!isDateCreatedClicked && !isRevisedDateClicked) {
      fetchSurvey();
      setshow(false);
      handleClearFleetSurveyId();
    } else {
      let created = moment(createdDate).format(DATE_FORMATE);
      let revised = moment(revisedDate).format(DATE_FORMATE);
      const response = await fetchSurveyWithFilter(name, created, revised);
      setAllSurveyList(response?.surveys);
      setshow(!show);
      setIsFilterWithDate(true);
      handleShowSelectedFilterDate();
      handleClearFleetSurveyId();
    }
  };

  const handleClearDateForFilter = () => {
    setCreatedDate(null);
    setRevisedDate(null);
    setIsRevisedDateClicked(false);
    setIsDateCreatedClicked(false);
  };

  const handleShowSelectedFilterDate = () => {
    if (isFilterWithDate && isDateCreatedClicked && !isRevisedDateClicked) {
      return DATE_CREATED_FILTER_BY_LABEL + " -  " + createdDate;
    } else if (
      isFilterWithDate &&
      !isDateCreatedClicked &&
      isRevisedDateClicked
    ) {
      return DATE_REVISED_FILTER_BY_LABEL + " - " + revisedDate;
    } else {
      return "";
    }
  };

  return (
    <React.Fragment>
      <Box className="m-top-14">
            <FormControl
          data-testid="mapping-section"
          error={isImportBtnCliked && vehicleTypeId === "" ? true : false}
          fullWidth
          sx={{
            flexDirection: "row",
            alignItems: "center",
          }}
        >
          <div className="w-12-em">
            <label>
              1. {t("tab2.contents.upload_section.Fleet_Survey_vehicle_type")} :
            </label>
          </div>
          <div className="w-14-em">
            <Select
              size="small"
              labelId="demo-select-big-label"
              id="demo-select-big"
              className="w-14-em"
              name="vehicleTypeId"
              value={vehicleTypeId}
              onChange={handleChangeVehicleType}
              MenuProps={{
                style: {
                  maxHeight: 400,
                },
              }}
            >
              <MenuItem value="">
                <em>{t("tab1.contents.Select_Vehicle_Type")}</em>
              </MenuItem>
             
              {allSurveyVehicleType?.map((ele, key) => {
                return (
                  <MenuItem value={ele?.typeId} key={key}>
                    {ele.type}
                  </MenuItem>
                );
              })}
            </Select>
          </div>
          {isImportBtnCliked && vehicleTypeId === "" && (
            <FormHelperText style={HELPER_TEXT_STYLE}>
              {SELECT_VEHICLE_TYPE}
            </FormHelperText>
          )}
        </FormControl>  
         <br />
        <br /> 
        <FormControl
          fullWidth
          sx={{
            flexDirection: "row",
            alignItems: "center",
            marginTop:'5px'
          }}
        >
          
          <div className="select-file-wdth" data-testid="select-file">
            <label>2. {t("tab2.contents.upload_section.Select_File")} :</label>
          </div>
          <div data-testid="select-file-from-file-type">
            <label className="label button-style">
              <input
                type="file"
                onClick={handleFileInputClick}
                onChange={(e) => handleFileUpload(e)}
                accept=".txt, .csv, .xls,.xlsx"
                data-testid="upInput"
                id="fileInputForImport"
                disabled={isFileUploadClick&&vehicleTypeId===""}
              />
              <span>{t("tab2.contents.upload_section.Select")}</span>
            </label>

            <input ref={fileInput} type="file" className="display-none" />
          </div>
          &nbsp; {uploadedFileName}
          {isFileUploadClick && vehicleTypeId===""&&
          <FormHelperText style={HELPER_TEXT_STYLE}>
              {SELECT_VEHICLE_TYPE}
            </FormHelperText>}
        </FormControl>
        <br />
        <br />
        <FormControl sx={{ flexDirection: "row", alignItems: "center" }}>
          <div className="w-190" data-testid="coloumn-delim">
            <label>
              3. {t("tab2.contents.upload_section.Column_Delimiter")} :
            </label>
          </div>
          <RadioGroup
            row
            data-testid="demo-row-radio-buttons-group-label"
            aria-labelledby="demo-row-radio-buttons-group-label"
            name="row-radio-buttons-group"
          >
            <FormControlLabel
              value="Txt"
              control={<Radio checked={fileExtension === "txt"} />}
              label={t("tab2.contents.upload_section.Tab")}
            />
            <FormControlLabel
              value="Csv"
              control={<Radio checked={fileExtension === "csv"} />}
              label={t("tab2.contents.upload_section.Comma")}
            />
          
          <FormControlLabel
              value={fileExtension}
              control={<Radio checked={ ["xls","xlsx"].includes(fileExtension)} />}
              label={t("tab2.contents.upload_section.xls")}
            />
          </RadioGroup>
        </FormControl>
        <br />
        <br />

        <FormControl
          fullWidth
          sx={{
            flexDirection: "row",
            alignItems: "center",
          }}
        >
          <div className="w-190">
            <label>
              4. {t("tab2.contents.upload_section.Upload_Data_into_grid")} :
            </label>
          </div>
          <div>
            <ButtonView
              data-testid="button"
              testid="import-upload-btn"
              label={t("tab2.contents.upload_section.Upload")}
              variant="contained"
              color="primary"
              disabled={disabled}
              onClick={() => {
                handleHideShowTable();
              }}
            ></ButtonView>
          </div>
        </FormControl>
        <br />
        <br />
        <FormControl
          fullWidth
          sx={{
            flexDirection: "row",
            alignItems: "center",
          }}
        >
          <div className="w-190">
            <label>
              5. {t("tab2.contents.upload_section.Fleet_Survey_Filter")} :
            </label>
          </div>
          <div style={{ position: "relative" }}>
            <div
              data-testid="filter-by-button-container"
              testid="filter-by-button-container"
              onClick={() => {
                setshow(!show);
              }}
            >
              <ButtonView
                label={t("tab2.contents.upload_section.Filter_By")}
                data-testid="filter-btn"
              ></ButtonView>
              <span className="selected-date-text">
                {handleShowSelectedFilterDate()}
              </span>
            </div>
            {show && (
              <DatePickerFilterBy
                testid="datepicker"
                createdDate={createdDate}
                revisedDate={revisedDate}
                handleChangeDate={handleChangeDate}
                handleChangeRevisedDate={handleChangeRevisedDate}
                handleFetchSurveysWithFilter={handleFetchSurveysWithFilter}
                handleClearDateForFilter={handleClearDateForFilter}
                isDateCreatedClicked={isDateCreatedClicked}
                isRevisedDateClicked={isRevisedDateClicked}
              />
            )}
          </div>
        </FormControl>
        <br />
        <br />
        <FormControl
          data-testid="mapping-section"
          error={isImportBtnCliked && fleetSurvetId === "" ? true : false}
          fullWidth
          sx={{
            flexDirection: "row",
            alignItems: "center",
          }}
        >
          <div className="w-12-em">
            <label>
             6. {t("tab2.contents.upload_section.Fleet_Survey_name")} :
            </label>
          </div>
          <div className="w-14-em">
            <Select
              size="small"
              labelId="demo-select-big-label"
              id="demo-select-big"
              className="w-14-em"
              name="fleetSurvetId"
              value={fleetSurvetId}
              onChange={handleChangeFleetSurveyName}
              MenuProps={{
                style: {
                  maxHeight: 400,
                },
              }}
            >
              <MenuItem value="">
                <em>{t("tab1.contents.Select_Survey")}</em>
              </MenuItem>
              {allSurveyList?.map((ele, key) => {
                return (
                  <MenuItem value={ele.id} key={key}>
                    {ele.surveyName}
                  </MenuItem>
                );
              })}
            </Select>
          </div>
          {isImportBtnCliked && fleetSurvetId === "" && (
            <FormHelperText style={HELPER_TEXT_STYLE}>
              {SELECT_SURVEY}
            </FormHelperText>
          )}
        </FormControl>
      </Box>
    </React.Fragment>
  );
};

export default ImportForm;
